module.exports = __webpack_public_path__ + "static/slide2-ea29f4084bc49f886d2ced494e5c5c09.webp";